// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ecdca864","396":"b78eb6c2","455":"32f4429c","977":"e4fa84a9"}[chunkId] + ".chunk.js";
};